import React, { lazy } from 'react';
import { CalendarIcon, FileTextIcon, CheckCircleIcon } from 'lucide-react';
import { Reveal } from './Reveal';
import { Divider } from './Divider';
const IMG = 'https://cdn.magicpatterns.com/uploads/kh8kGEHNiFrx5XwSLvkrqs/mujer_con_celular.webp';
const features = [{
  icon: CalendarIcon,
  title: 'Un 1% cada día, durante 30 días',
  desc: 'Pequeños ajustes diarios que se sienten posibles y se acumulan en un cambio real.'
}, {
  icon: FileTextIcon,
  title: 'Acciones simples para tu rutina',
  desc: 'Pasos claros que puedes aplicar sin darle la vuelta a tu día ni invertir horas.'
}, {
  icon: CheckCircleIcon,
  title: 'Tu progreso, sin presión',
  desc: 'Marca lo que haces y celebra cada avance, a tu ritmo y con calma.'
}];
export function WhatIsSection() {
  return <section className="w-full bg-white py-20 sm:py-28" data-id="element-186" data-mp="35a3dtnjysl3q">
      <div className="mx-auto max-w-6xl px-4 sm:px-6" data-id="element-187" data-mp="3a9prfy3pg3d2">
        <Reveal className="mx-auto max-w-2xl text-center" data-id="element-188" data-mp="3a8eog0i32zn0">
          <h2 className="font-serif text-3xl font-semibold text-tinta sm:text-4xl lg:text-5xl" data-id="element-189" data-mp="kg8u7hr9berj">
            Tu coach hormonal en la palma de tu mano
          </h2>
          <p className="mt-4 text-lg leading-relaxed text-tinta/70" data-id="element-190" data-mp="gcaxtetbgi26">
            El Método del 1% convierte el cambio en algo posible: una acción
            sencilla cada día, sin complicarte ni dedicar horas extra. Solo
            pequeños pasos que, con el tiempo, te devuelven a ti.
          </p>
        </Reveal>

        <div className="mt-12 grid items-center gap-12 lg:grid-cols-2 lg:gap-16" data-id="element-191" data-mp="3svsn2fo0mv62">
          <Reveal data-id="element-192" data-mp="3stplcydi3dli">
            <div className="overflow-hidden rounded-3xl shadow-xl shadow-tinta/10" data-id="element-193" data-mp="3otp65bikuyde">
              <img src={IMG} alt="Mujer sonriente usando la app Cambio Hormonal desde una cama acogedora con luz cálida" className="h-full max-h-[560px] w-full object-cover" loading="lazy" data-id="element-194" data-mp="3juuhvu1uchlw" />
            </div>
          </Reveal>

          <div className="grid gap-5" data-id="element-195" data-mp="309c3pwgkg7dr">
            {features.map((f, i) => <Reveal key={f.title} delay={i * 0.1} data-id="element-196" data-mp="30bf3h87itevo" data-mpi={i}>
                <div className="flex gap-5 rounded-2xl border border-nude/60 bg-crema/50 p-5 sm:p-6" data-id="element-197" data-mp="3596s9tcvckvn">
                  <span className="flex h-12 w-12 shrink-0 items-center justify-center rounded-2xl bg-rosa/15 text-rosa-dark" data-id="element-198" data-mp="2r9pd85pdklzh">
                    <f.icon className="h-6 w-6" strokeWidth={1.6} data-id="element-199" data-mp="2va96uzaqp7gv" />
                  </span>
                  <div data-id="element-200" data-mp="3j0by5d6ty9ef">
                    <h3 className="font-serif text-xl font-semibold text-tinta" data-id="element-201" data-mp="3j1wkifizqm17">
                      {f.title}
                    </h3>
                    <p className="mt-1 text-tinta/70" data-id="element-202" data-mp="3a81mdrgadvv2">{f.desc}</p>
                  </div>
                </div>
              </Reveal>)}
          </div>
        </div>

        <div className="mt-16" data-id="element-203" data-mp="5ta8m3f2zekq">
          <Divider data-id="element-204" data-mp="5rz2vy22rwqz" />
        </div>
      </div>
    </section>;
}